import { Button } from "@material-ui/core";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import * as React from "react";
import {
  ICoach,
  ISport,
  ISurveyEvaluationRequest,
  ISurveyEvalResponse,
  ISurveyEvaluationResponses,
  ISurveyCoachEvaluationRequest,
  // ISchool,

} from "src/services";
import Component from "../../../components/Component";
import Modal, { IModalProps } from "../../../components/Modal";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import l from "../../../l";
import "./pagination.css";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import EmailValidator from "email-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as format from "date-fns/format";
// import { useReactToPrint } from 'react-to-print';
// import { useRef } from 'react';
import EvaluationPrinter, {
  PrintEvaluationFunc,
} from "./EvaluationPrinter";
import CoachReportPreview from "../CoachReportPreview/CoachReportPreview";
const CoachReportPreviewAny: any = CoachReportPreview;
// import school from "src/pages/home/school/school";
// import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";


const styles = (theme: Theme): Record<string, CSSProperties> => ({
  modal: {
    boxSizing: "border-box",
    height: "80%",
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    width: "80%",
  },
  summaryBox: {
    backgroundColor: "#efefef",
    border: "1px solid #424242",
    borderRadius: 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
      1
    )}px ${theme.spacing(1)}px`,
  },
  text: {
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
});

interface IExtraProps {
  slug: string;
  schoolId: number;
  // school: ISchool;
  surveyId: number;
  coach: ICoach;
  sport: ISport;
  startDate: number;
  endDate: number;
  isParentModal?: "true" | "false";
  schoolData: any
  ReportData: any
  refreshReports: () => Promise<void>;
  bindGenerateReport?: (fn: () => Promise<void>) => void;
  showLoaderStudent:boolean
  showLoaderParent:boolean
  editButtonLoading:boolean
  reportLoading: boolean;
  readOnly?: boolean;
}

type IBaseProps = IModalProps & IExtraProps;

type IProps = IBaseProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ISurveyResponsesModalState {
  loading?: true;
  index: number;
  surveyResponse?: ISurveyEvaluationResponses;
  showDeleteConfirmation?: true;
  isDeleting?: true;
  editableReportData?: any[];
  confirmGenerateReportOpen: boolean; // NEW

  emailModalOpen?: boolean;
  emailReportId?: number;
  emailValue?: string;
  emailSending?: boolean;
  emailError?: string;
  emailSuccess?: string;
  showLoader?: boolean;
  didObserveReportActivity: boolean;
}

export default withStyles(styles, { withTheme: true })(
  withAxios(
    class GenerateReportModal extends Component<
      IProps,
      ISurveyResponsesModalState
    > {
      public printEvaluation?: PrintEvaluationFunc;

      public readonly state = this.buildState({
        index: 0,
        editableReportData: [],
        confirmGenerateReportOpen: false,// add this

        showLoader: false, // <-- add this
        didObserveReportActivity: false,
      });

      public componentDidMount() {
        // Do not let cached edit state override a freshly opened report row.
        if (this.props.bindGenerateReport) {
          this.props.bindGenerateReport(() => this.GenerateReport());
        }
        const hasIncomingReportData =
          Array.isArray(this.props.ReportData) && this.props.ReportData.length > 0;
        if (hasIncomingReportData) {
          const editableReportData = this.props.ReportData.map((report: any) => ({
            ...report,
            chatgptChangeResposne: this.getParsedCoachReportPayload(report) || {},
          }));
          this.setState({ editableReportData });
        }
        const localData = localStorage.getItem("editableReportData");
        if (!hasIncomingReportData && localData) {
          try {
            const parsed = JSON.parse(localData);
            if (Array.isArray(parsed)) {
              this.setState({ editableReportData: parsed });
            }
          } catch (e) {
            // ignore parse error
          }
        }
        void this.loadAsync();
      }

      public componentDidUpdate(prevProps: IProps, prevState: ISurveyResponsesModalState) {
        if (this.props.open && !prevProps.open) {
          this.setState({ didObserveReportActivity: false });
        }

        const isAnyLoaderActive =
          this.state.showLoader ||
          this.props.showLoaderStudent ||
          this.props.showLoaderParent ||
          this.props.reportLoading;

        if (
          this.props.open &&
          isAnyLoaderActive &&
          !this.state.didObserveReportActivity
        ) {
          this.setState({ didObserveReportActivity: true });
        }

        if (this.props.ReportData !== prevProps.ReportData && this.props.ReportData) {
          // value change hua hai report data mei 
          // Parse all chatgptChangeResposne fields
          // const editableReportData = this.props.ReportData.map((report: any) => ({
          //   ...report,
          //   chatgptChangeResposne: report.chatgptChangeResposne
          //     ? JSON.parse(report.chatgptChangeResposne)
          //     : {},
          // }));

          
          {
            // console.log("tttttttttt", this.props.ReportData )
          }
          const editableReportData = this.props.ReportData.map((report: any) => {
            let parsedResponse = {};
            {
              // console.log("ttccccccccccccccc", report.chatgptChangeResposne )

            }

            try {
              parsedResponse = report.chatgptChangeResposne
                ? typeof report.chatgptChangeResposne === 'string'
                  ? JSON.parse(report.chatgptChangeResposne.replace(/[\r\n]+/g, ''))
                  : report.chatgptChangeResposne // already parsed
                : {};
            } catch (e) {
              console.warn("Invalid JSON in chatgptChangeResposne:", report.chatgptChangeResposne);
            }

            return {
              ...report,
              chatgptChangeResposne: parsedResponse,
            };
          });


          this.setState({ editableReportData });
        }
        // Store editableReportData in localStorage if it changes
        if (this.state.editableReportData !== prevState.editableReportData) {
          try {
            localStorage.setItem("editableReportData", JSON.stringify(this.state.editableReportData));
          } catch (e) {
            // ignore storage error
          }
        }
      }

      public readonly isCoachFrontendShapeReport = (payload: any): boolean => {
        if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
          return false;
        }

        // Only structured coach-report payloads should open in the new preview.
        // Legacy reports stay on the old renderer so their existing print/edit flow remains unchanged.
        return (
          typeof payload.overallSummary === "string" ||
          Array.isArray(payload.highlightsStrengths) ||
          Array.isArray(payload.suggestions) ||
          Array.isArray(payload.resources) ||
          !!payload.teamConnectedness ||
          !!payload.wiseLeadership ||
          !!payload.expectations ||
          !!payload.relationalWarmth ||
          !!payload.parentFeedback ||
          typeof payload.finalNote === "string"
        );
      };

      public readonly getActiveReportRow = () => {
        const propReport =
          Array.isArray(this.props.ReportData) && this.props.ReportData[0];
        const stateReport =
          this.state.editableReportData && this.state.editableReportData[0];

        // Prefer the parsed state row when it matches the same report id.
        // This keeps history/evaluation detection stable for new-format reports
        // while still leaving legacy reports on the old renderer.
        if (stateReport?.id && propReport?.id && stateReport.id === propReport.id) {
          return stateReport;
        }

        return stateReport || propReport || null;
      };
     
      public render() {
        const { open, classes, coach, sport, surveyId, schoolId, isParentModal, startDate
          // , ReportData 
        } = this.props;
        const activeReport = this.getActiveReportRow();
        const activeReportPayload =
          this.getParsedCoachReportPayload(activeReport) ||
          this.getParsedCoachReportPayload(
            Array.isArray(this.props.ReportData) ? this.props.ReportData[0] : null
          );
        const shouldUseCoachReportPreview =
          (this.isCoachFrontendShapeReport(activeReportPayload) ||
            this.isCoachFrontendShapeReport(
              this.getParsedCoachReportPayload(
                Array.isArray(this.state.editableReportData)
                  ? this.state.editableReportData[0]
                  : null
              )
            ));
        console.log("ReportData in GenerateReportModal:", this.props.ReportData, this.props);
        return (
          <>
            <EvaluationPrinter printEvaluationRef={this.setPrintEvaluation} />
            <Modal
              open={open}
              closeModal={this.props.closeModal}
              className={classes.modal}
            >
              {console.log(this.props?.showLoaderStudent,"props?showLoaderStudent")}
                  {console.log(this.props?.showLoaderParent,"this.props?.showLoaderParent")}

              {shouldUseCoachReportPreview ? (
                <CoachReportPreviewAny
                  schoolId={schoolId}
                  sportId={sport && sport.id}
                  coachId={coach && coach.id}
                  surveyId={surveyId}
                  year={new Date(startDate ?? Date.now()).getFullYear()}
                  type="coach"
                  isParentResponses={isParentModal === "true"}
                  readOnly={Boolean(this.props.readOnly)}
                  pageName="reportmodal"
                  coachName={coach && coach.name}
                  isAdSurvey={Boolean(
                    this.props.schoolData &&
                      ((this.props.schoolData as any).isAdSurvey ||
                        (this.props.schoolData as any).isAdSurveyStatus)
                  )}
                  primaryColor={
                    this.props.schoolData && this.props.schoolData.primaryColor
                  }
                  reportId={activeReport && activeReport.id ? activeReport.id : undefined}
                  onSaveReport={
                    this.props.readOnly ? undefined : this.handleSaveCoachReport
                  }
                />
              ) : (
                // Legacy reports continue to use the existing renderer and print flow.
                this.renderEditableReportData()
              )}

            </Modal>
          </>

        );
      }
      // public readonly handlePrintClick = () => {
      //     if (this.printEvaluation === undefined) {
      //       throw new Error("There is not print");
      //     }
      //     // const {"", coach, surveyId } = this.props;
      //   //  schoolData
      //    console.log(schoolData,"schoolData")
      //     // this.printEvaluation(surveyId, coach.id);
      //   };
      public readonly handlePrintClick = () => {
        if (this.printEvaluation === undefined) {
          throw new Error("There is not print");
        }

        const { schoolData, coach, surveyId, slug } = this.props;
        //   console.log(schoolData,"schoolData")
        //     console.log(coach,"coach")
        //         console.log(surveyId,"surveyId")
        // console.log(slug,"slug testing ")

        const schoolWithSlug = {
          ...schoolData,
          slug,
        };
        // console.log(schoolWithSlug,"schoolWithSlug")

        this.printEvaluation(schoolWithSlug, surveyId, coach.id);

        // this.printEvaluation?.(this.props.schoolData, this.props.surveyId, this.props.coach.id);

        // console.log(schoolData, "schoolData");

        // Example: if printEvaluation expects schoolId instead of full object
        // this.printEvaluation(schoolData, surveyId, coach.id);
      };


      public readonly setPrintEvaluation = (
        printEvaluation: PrintEvaluationFunc | null
      ) => {
        this.printEvaluation =
          printEvaluation === null ? undefined : printEvaluation;
        // this.setState({
        //   showPrintButton: this.printEvaluation && true,
        // });
      };
      private readonly getParsedCoachReportPayload = (reportRow: any) => {
        const payload = reportRow?.chatgptChangeResposne;

        if (!payload) {
          return null;
        }

        if (typeof payload === "string") {
          try {
            return JSON.parse(payload.replace(/[\r\n]+/g, ""));
          } catch (error) {
            console.warn("Invalid coach report payload:", payload);
            return null;
          }
        }

        return payload;
      };

      private readonly getNormalizedReportRows = (reportRows: any[] = []) => {
        return reportRows.map((reportRow: any) => ({
          ...reportRow,
          chatgptChangeResposne: this.getParsedCoachReportPayload(reportRow) || {},
        }));
      };

      private readonly loadAsync = async () => {
        const { isParentModal = "false" } = this.props;

        await this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: undefined,
          },
          async () => {
            const { surveyId, coach } = this.props;
            const surveyResponse = await this.buildGetWithParams<
              ISurveyEvaluationResponses,
              ISurveyEvaluationRequest
            >(
              this,
              l`surveys/${surveyId}/evaluations/coach/${coach.id}`
            )({
              isParentResponses: isParentModal,
              schoolSlug: this.props.slug,
            });
            this.setState({ surveyResponse });
          },
          () => {
            this.setState({
              loading: undefined,
            });
          }
        );
      };

      // private handleOpenEmailModal = (reportId: number) => {
      //   this.setState({ emailModalOpen: true, emailReportId: reportId, emailValue: "", emailError: "", emailSuccess: "" });
      // };

      private handleCloseEmailModal = () => {
        this.setState({ emailModalOpen: false, emailReportId: undefined, emailValue: "", emailError: "", emailSuccess: "" });
      };

      private handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ emailValue: e.target.value, emailError: "", emailSuccess: "" });
      };

      private handleSendEmail = async () => {
        const { emailReportId, emailValue } = this.state as any;
        const isEmailValid = EmailValidator.validate(emailValue);
        if (!emailValue || !isEmailValid) {
          this.setState({ emailError: "Please enter a valid email address." });
          return;
        }
        this.setState({ emailSending: true, emailError: "", emailSuccess: "" });
        try {
          await this.buildPost<any, any>(
            this,
            "/reports/reportSend"
          )({ id: emailReportId, email: emailValue });
          this.setState({ emailSending: false, emailSuccess: "Email sent successfully!" });
          this.handleCloseEmailModal();
        } catch (error) {
          this.setState({ emailSending: false, emailError: "Failed to send email." });
        }
      };

      private saveReportUpdate = async (
        chatgptChangeResposne: any,
        reportRow?: any
      ) => {
        const report =
          reportRow ||
          (this.state.editableReportData && this.state.editableReportData[0]) ||
          (Array.isArray(this.props.ReportData) && this.props.ReportData[0]);

        if (!report?.id) {
          throw new Error("Report id is missing.");
        }

        const updatedReport = {
          ...report,
          chatgptChangeResposne:
            typeof chatgptChangeResposne === "string"
              ? chatgptChangeResposne
              : JSON.stringify(chatgptChangeResposne),
          type: "coach",
        };

        return this.buildPost<any, any>(this, "/reports/reportUpdate")([
          updatedReport,
        ]);
      };

      private handleSaveCoachReport = async (
        chatgptChangeResposne: Record<string, unknown>
      ): Promise<boolean> => {
        try {
          await this.saveReportUpdate(chatgptChangeResposne);

          const wiseLeadership = (chatgptChangeResposne as any).wiseLeadership || {};

          const currentEvaluation = await this.buildGetWithParams<
            ISurveyEvalResponse,
            ISurveyEvaluationRequest
          >(
            this,
            l`survey/${this.props.surveyId}/evaluation/${this.props.coach.id}`
          )({
            isParentResponses: this.props.isParentModal || "false",
            schoolSlug: this.props.slug,
          });

          await this.buildPut<Partial<ISurveyCoachEvaluationRequest>, void>(
            this,
            l`survey/${this.props.surveyId}/evaluation/${this.props.coach.id}`
          )({
            coachCommitments:
              typeof chatgptChangeResposne.leaderCommitments === "string"
                ? chatgptChangeResposne.leaderCommitments
                : "",
            directorComments:
              typeof wiseLeadership.administratorComments === "string"
                ? wiseLeadership.administratorComments
                : "",
            parentComments: currentEvaluation.parentComments || "",
            schoolId: this.props.schoolId,
            submitted: Boolean(currentEvaluation.submitted),
          });

          await this.props.refreshReports();
          return true;
        } catch (error) {
          console.error("Error saving coach report preview", error);
          return false;
        }
      };

      private GenerateReport = async () => {
        const { sport, coach, refreshReports } = this.props;
        this.setState({ showLoader: true }); // Show loader
        try {
          // console.log("GenerateReport called",this.props);
          const startTs = this.props.startDate ?? Date.now();
          const year = new Date(startTs).getFullYear().toString();
          // console.log(year)
          const notificationUpgraded = await this.buildPost<{ sportId: any, type: any, coachId: any, schoolId: any, year: string, surveyId: any }, any>(
            this, "/reports/survey/evaluation/by-ids"
          )({
            schoolId: this.props?.schoolId,
            sportId: sport?.id,
            coachId: coach?.id,
            type: "coach",
            year: year.toString(),
            surveyId: this.props?.surveyId

            // year,
          });
          console.log("notificationUpgraded", notificationUpgraded);
          // Parent data refresh karein
          if (typeof refreshReports === "function") {
            await refreshReports();
          }
        } catch (error) {
          console.error("Error in notificationUpgraded:", error);
        } finally {
          this.setState({ showLoader: false }); // Hide loader
        }
      }
      private renderEmailModal() {
        const { emailModalOpen, emailValue, emailSending, emailError, emailSuccess } = this.state as any;
        return (
          <Dialog open={!!emailModalOpen} onClose={this.handleCloseEmailModal}>
            <DialogTitle>Send Report on Email</DialogTitle>
            <DialogContent>
              <TextField
                label="Recipient Email"
                type="email"
                value={emailValue || ""}
                onChange={this.handleEmailChange}
                fullWidth={true}
                autoFocus={true}
                disabled={emailSending}
                margin="dense"
              />
              {emailError && <div style={{ color: "red", marginTop: 8 }}>{emailError}</div>}
              {emailSuccess && <div style={{ color: "green", marginTop: 8 }}>{emailSuccess}</div>}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseEmailModal} color="secondary" disabled={emailSending}>
                Cancel
              </Button>
              <Button onClick={this.handleSendEmail} color="primary" disabled={emailSending}>
                {emailSending ? "Sending..." : "Send"}
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      private renderEditableReportData() {
        const { confirmGenerateReportOpen } = this.state as any;
        const stateEditableReportData = Array.isArray(this.state.editableReportData)
          ? this.state.editableReportData
          : [];
        const propEditableReportData = this.getNormalizedReportRows(
          Array.isArray(this.props.ReportData) ? this.props.ReportData : []
        );
        const activeReport = this.getActiveReportRow();
        const editableReportData =
          stateEditableReportData.length > 0 &&
          activeReport?.id &&
          stateEditableReportData[0]?.id === activeReport.id
            ? stateEditableReportData
            : propEditableReportData;

        // Open confirmation popup
        // const handleOpenConfirmPopup = () => {
        //   this.setState({ confirmGenerateReportOpen: true });
        // };

        // Close popup without action
        const handleCloseConfirmPopup = () => {
          this.setState({ confirmGenerateReportOpen: false });
        };

        // Confirm and run GenerateReport
        const handleConfirmGenerateReport = () => {
          this.setState({ confirmGenerateReportOpen: false }, () => {
            this.GenerateReport();
          });
        };
        // Button ko hamesha return karo
        const generateReportButton = (
          <>
            {/* <Button
                type="button"
                variant="contained"
                color="primary"
                style={{
                  margin: "24px 0",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
                onClick={handleConfirmGenerateReport} // Confirmation first
              >
                Generate Report
              </Button> */}
        
            {/* Confirmation Popup */}
            <Dialog
              open={confirmGenerateReportOpen}
              onClose={handleCloseConfirmPopup}
            >
              <DialogTitle>Confirm Report Generation</DialogTitle>
              <DialogContent>
                Are you sure all your data is recorded? You can only generate this summary report once.
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseConfirmPopup} color="secondary">
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmGenerateReport}
                  color="primary"
                  variant="contained"
                >
                  Yes, Generate
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );

        const isAnyLoaderActive =
          this.state.showLoader ||
          this.props.showLoaderStudent ||
          this.props.showLoaderParent ||
          this.props.reportLoading;
        const shouldShowEmptyState =
          this.state.didObserveReportActivity &&
          !isAnyLoaderActive;

        if (!editableReportData || !Array.isArray(editableReportData) || editableReportData.length === 0) {
          if (!shouldShowEmptyState) {
            return (
              
            
                // { (this.props?.showLoaderStudent || this.props?.showLoaderParent || this.state?.showLoader) && (

    

                <div
                  style={{
                    position: "absolute", // absolute to modal
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >
                  
                  <CircularProgress size={60} style={{ color: "#1976d2" }} />
                  <div style={{ color: "#fff", fontSize: 22, marginTop: 24, textAlign: "center" }}>
                  Generating your data. This may take 30 seconds to 3 minutes, please don't close this window.
                    {/* Generating report... Do Not Refresh Your Screen. */}
                    {/* Summary generation in progress, Do not refresh your screen. Please wait... */}
                  </div>
                </div>
              
            );
          }

          return (
            <div
              style={{
                width: "100%",
                minHeight: "calc(80vh - 64px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "32px 24px",
                boxSizing: "border-box",
              }}
            >
              {generateReportButton}
              <div
                style={{
                  maxWidth: 560,
                  width: "100%",
                  textAlign: "center",
                  background: "#f7f7f7",
                  border: "1px solid #d8d8d8",
                  borderRadius: 12,
                  padding: "40px 28px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                  margin: "0 auto",
                }}
              >
                <div
                  style={{
                    fontSize: 26,
                    fontWeight: 700,
                    color: "#333",
                    marginBottom: 12,
                  }}
                >
                  No data available to display
                </div>
              
              </div>
            </div>
          );
        }
        // const formatPoints = (input: any) => {
        //   console.log("inputttttttttt", input)
        //   return input
        //     // .trim()
        //     // .replace(/\s*\.\s*$/, '')
        //     // .split(/(?=\d+\.\s)/);
        // };

        //  function cleanAndFormatHtml(input: string): string {
        //     if (typeof input !== "string") {
        //         return "";
        //       }
        //       const html = input
        //         .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
        //         .replace(/\*(.*?)\*/g, "<b>$1</b>");

        //       const div = document.createElement("div");
        //       div.innerHTML = html;

        //       div.querySelectorAll("style").forEach(tag => tag.remove());
        //       div.querySelectorAll("[style]").forEach(el => el.removeAttribute("style"));

        //       return div.innerHTML;
        //     }

        function cleanAndFormatHtml_New(input: string): string {
          const html = input
            .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
            .replace(/\*(.*?)\*/g, "<b>$1</b>");

          const div = document.createElement("div");

          // If no HTML tags exist, wrap text in a span so styles can be applied
          if (!/<[a-z][\s\S]*>/i.test(html)) {
            div.innerHTML = `<span>${html}</span>`;
          } else {
            div.innerHTML = html;
          }

          div.querySelectorAll<HTMLElement>("*").forEach(el => {
            // el.style.color = "red";
            el.style.setProperty("font-family", '"Open Sans", sans-serif');

          });
          // console.log("innerHtml:::::::", div.innerHTML);

          return div.innerHTML; // Now contains inline styles
        }



        return (
          <div>
            <h1 style={{ textAlign: "left", fontSize: "28px", marginBottom: 15 }}>{this.props?.coach.name} Seasonal Report</h1>
            {/* {generateReportButton}  */}

            {editableReportData.slice(0, 1).map((report: any, reportIdx: number) => (

              <form
                key={report.id}
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const UpdateReportData = await this.saveReportUpdate(
                      report.chatgptChangeResposne,
                      report
                    );
                    console.log("Report updated successfully:", UpdateReportData);
                    alert("Report updated successfully!");
                    this.props.refreshReports();
                  } catch (error) {
                    console.error("Error in ReportData", error);
                  }
                }}



                style={{
                  marginBottom: 32,

                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: "15px", justifyContent: "space-between", marginBottom: 16 }}>

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3 style={{ marginBottom: "0" }}>{this.props?.schoolData?.name}</h3>
                    <img src={this.props?.schoolData?.logo1} alt="School Logo" style={{ width: 50, height: 50 }} />
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <div className="" style={{ color: "#000", fontWeight: "bold", fontSize: "12px", display: "flex", justifyContent: "start", gap: "25px" }}>
                        <div> {format(report.date, "MMMM D, YYYY")}</div>
                        <div>{this.props?.coach.name} </div>
                        <div> {this.props?.sport.name} </div>
                      </div>
                      {/* { 
                      this.props?.schoolData.ismidseason ?
                      <>
                        </>
                      : " " 
                       
                       } */}
                      {/* <div style={{ fontWeight: 500, color: "#555" }}> Coach: {this.props?.coach.name} </div> 
                      <div style={{ fontWeight: 500, color: "#555" }}> Sport: {this.props?.sport.name} </div> 
                     
                      <div style={{ fontWeight: 500, color: "#555" }}>Report Generated On: {format(report.date, "MMMM D, YYYY")}</div> */}

                      {/* <div style={{ fontWeight: 500, color: "#555" }}>Session: {report.sessionType}</div> */}
                    </div>
                    <div 
                    // style={{ display: "flex", justifyContent: "space-between" }}
                    >
{/* console.log(this.props?.showLoaderStudent,"props?showLoaderStudent")}
{console.log(this.props?.showLoaderParent,"this.props?.showLoaderParent")} */}
{(!this.props?.showLoaderParent && !this.props?.showLoaderStudent ) &&(
  <Button
    onClick={this.handlePrintClick}
    type="button"
    variant="contained"
    color="secondary"
    style={{ marginRight: "10px" }}
  >
    Print
  </Button>
) }

{/* {!this.props?.showLoaderParent && !this.props?.showLoaderStudent ? (
  <Button
    onClick={this.handlePrintClick}
    type="button"
    variant="contained"
    color="secondary"
    style={{ marginRight: "10px" }}
  >
    Print
  </Button>
) : (
  <Button
    type="button"
    variant="contained"
    color="secondary"
    style={{ marginRight: "10px" }}
    onClick={() => alert("Please wait, summary not generated yet")}
  >
    Print
  </Button>
)} */}


                    {!this.props.readOnly && (
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: 0, float: "right", marginBottom: "15px" }}
                      >
                        Update
                      </Button>
                    )}
                    </div>


                   
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #eee", margin: "15px 0 14px 0" }} />

                {/* {Object.keys(report.chatgptChangeResposne).map((key) => {
                  console.log("kayyyyyyyyyyy", key)
                  const original = report.chatgptChangeResposne[key] || '';

                  console.log("originalttttt", original)
                  const value = String(original).includes('\n')
                    ? String(original)
                    : String(original);

                    let titleContent;
 
                  return (
                    <> {value !== null &&
                      <div key={key} style={{ marginBottom: 24 }}>

                         {titleContent} 
                        <label className="title-fontFamily" style={{
                          fontWeight: "400",
                          fontSize: 22,
                          display: "block",
                          marginBottom: 6,
                          color: "white",
                          padding: 8,
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                          backgroundColor: this.props.schoolData?.primaryColor

                        }}>
                          {key}:
                        </label>
                       
                        {typeof value === 'object' && value !== null ? (
                  
                            <pre style={{
                              background: "#f4f4f4",
                              padding : 12,
                              borderRadius: 4,
                              border: "1px solid #bbb",
                              fontSize: 14,
                              overflowX: "auto"
                            }}>
                              {JSON.stringify(value, null, 2)}
                            </pre>
                          ) : (

                      
                          <textarea className="textarea-fontFamily"
                            style={{
                              width: "100%",
                              minHeight: 80,
                              fontSize: 13,
                              padding: 10,
                              borderRadius: 4,
                              border: "1px solid #bbb",
                              background: "#fff",
                              lineHeight: "17px",
                              resize: "vertical",
                              pointerEvents: this.props.readOnly ? "none" : undefined
                            }}
                            value={value}
                            readOnly={Boolean(this.props.readOnly)}
                            tabIndex={this.props.readOnly ? -1 : 0}
                            onChange={this.props.readOnly ? undefined : (e) => {
                              const newReports = [...editableReportData];
                              newReports[reportIdx] = {
                                ...newReports[reportIdx],
                                chatgptChangeResposne: {
                                  ...newReports[reportIdx].chatgptChangeResposne,
                                  [key]: e.target.value,
                                },
                              };
                              this.setState({ editableReportData: newReports });
                            }}
                          />
                        )}
                      </div>
       
                    }</>
                  );
                })} */}


                {Object.keys(report.chatgptChangeResposne).map((key) => {
                  const original = report.chatgptChangeResposne[key] || '';
                  const value = String(original);

                  let contentBody = null;

                  // Special rendering for "Team Connectedness:"
                  if (key.trim().toLowerCase().includes("team connectedness")) {
                    contentBody = (
                      <div className="team-connectedness-section" style={{ marginBottom: 20, border: "1px solid rgb(187, 187, 187)", fontSize: "13px", padding: "5px", borderRadius: "4px" }}>
                        <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }}>
                          <span className="textarea-fontFamily"
                            dangerouslySetInnerHTML={{
                              __html: value.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>").replace(/\*(.*?)\*/g, "<b>$1</b>")
                            }}
                          />
                        </pre>
                      </div>
                    );
                  } else {
                    contentBody = (
                      <div
                        className="editable-div textarea-fontFamily"
                        contentEditable={!this.props.readOnly}
                        suppressContentEditableWarning={true}
                        tabIndex={this.props.readOnly ? -1 : 0}
                        style={{
                          width: "100%",
                          minHeight: 80,
                          fontSize: 13,
                          padding: 10,
                          borderRadius: 4,
                          border: "1px solid #bbb",
                          background: "#fff",
                          lineHeight: "17px",
                          whiteSpace: "pre-wrap",
                          pointerEvents: this.props.readOnly ? "none" : undefined
                        }}
                        dangerouslySetInnerHTML={{
                          __html: cleanAndFormatHtml_New(typeof value === "string" ? value : "")
                        }}
                        onBlur={this.props.readOnly ? undefined : (e) => {
                          const rawHTML = e.target.innerHTML;
                          const cleanedHTML = cleanAndFormatHtml_New(rawHTML);

                          const newReports = [...editableReportData];
                          newReports[reportIdx] = {
                            ...newReports[reportIdx],
                            chatgptChangeResposne: {
                              ...newReports[reportIdx].chatgptChangeResposne,
                              [key]: cleanedHTML
                            }
                          };

                          this.setState({ editableReportData: newReports });

                        }}

                        onPaste={this.props.readOnly ? undefined : (e) => {
                          e.preventDefault();
                          const text = e.clipboardData.getData("text/plain");
                          document.execCommand("insertHTML", false, cleanAndFormatHtml_New(text));
                        }}
                      />

                    );
                  }



                  return (
                    <div key={key} style={{ marginBottom: 24 }}>
                      <label
                        className="title-fontFamily"
                        style={{
                          fontWeight: "400",
                          fontSize: "17px",
                          display: "block",
                          marginBottom: 6,
                          color: "white",
                          lineHeight: "26px",
                          padding: "0px 8px",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                          backgroundColor: this.props.schoolData?.primaryColor
                        }}
                      >
                        {key}
                      </label>

                      {contentBody}
                    </div>
                  );
                })}
                <div style={{ paddingBottom: "15px", marginBottom: "15px" }}>
                  {!this.props.readOnly && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 0, float: "right", marginBottom: "15px" }}
                    >
                      Update
                    </Button>
                  )}
                </div>
                <style>
                  {`
                  .nowrape {
                     white-space: nowrap;
                  }
                  .title-heading {
                    font-family: "Russo One", Arial, sans-serif !important;
                    font-size: 24px;
                    margin-bottom: 3px;
                  }
                   .team-connectedness-section p {
                     font-weight:bold;
                     font-size:13px;
                    } 
                     .team-connectedness-section table thead th {
                      white-space:nowrap;
                    }
                     .team-connectedness-section p,  
                    .textarea-fontFamily, .textarea-fontFamily * {
                      font-family: Open Sans, sans-serif !important;	
                    }
                  .page-break {
                    page-break-before: always;
                    break-before: page;
                  }
                  @media print {
                    .print-footer-logo {
                      display: block !important;
                      position: fixed !important;
                      bottom: 24px !important;
                      left: 50% !important;
                      transform: translateX(-50%) !important;
                      width: 40px !important;
                      z-index: 10000 !important;
                      page-break-after: avoid !important;
                    }
                    body {
                      -webkit-print-color-adjust: exact !important;
                      print-color-adjust: exact !important;
                    }
                    .titleColored {
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
                     .textarea-fontFamily {
                      font-family: Open Sans, sans-serif !important;	
                    }
                     .footer-logo {
                                  position: fixed !important;
                                  bottom: 10px !important;
                                  width: 100%;
                                  text-align: center;
                                  left: 0%;
                                  transform: translateX(50%, 50%);
                                                  
                              }
                          
                              .footer-logo img {
                                  height: 27px !important;
                                  width: 27px!important;
                                  bottom:0px !important;
                                      position: absolute !important;
                                  text-align: center;
                                  transform: translateX(50%, -50%);
                                  left: 48% !important;
                              }   
                                @page {
                                margin-bottom: 20mm; /* Prevent clipping at bottom */
                              }  
                  }  
                `}
                </style>



                <div id={`printable-report-${report.id}`} style={{ display: "none", border: "none", position: "relative" }}>
                  <div style={{ border: "none" }}>

                    <div style={{ marginBottom: "20px" }}>

                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <h2 style={{ textAlign: "left" }}>Annual Report</h2>
                          <h3>{this.props?.schoolData?.name} </h3>
                        </div>
                        <div>
                          <img src={this.props?.schoolData?.logo1} alt="School Logo" style={{ position: "relative", top: "-5px", width: 70, height: 70 }} />
                        </div>
                      </div>
                      {/* { 
                      this.props?.schoolData.ismidseason ?
                      <>
                       </>
                       : " " 
                       
                       } */}
                      {/* <strong style={{ fontWeight: 500, color: "#555" }}> Coach: {this.props?.coach.name} </strong> <br />
                      <strong style={{ fontWeight: 500, color: "#555" }}> Sport: {this.props?.sport.name} </strong> <br />
                      
                      <strong style={{ fontWeight: 500, color: "#555" }}>Report Generated On: {format(report.date, "MMMM D, YYYY")}</strong> <br /> */}
                      {/* <strong style={{ fontWeight: 500, color: "#555" }}>Session:</strong> {report.sessionType} */}
                    </div>
                    <div className="" style={{ color: "#000", marginBottom: "10px", fontWeight: "bold", fontSize: "18px", display: "flex", justifyContent: "start", gap: "25px" }}>
                      <div> {format(report.date, "MMMM D, YYYY")}</div>
                      <div>{this.props?.coach.name} </div>
                      <div> {this.props?.sport.name} </div>

                    </div>

                    {Object.keys(report.chatgptChangeResposne).map((key, index) => {
                      // const value = report.chatgptChangeResposne[key];
                      const original = report.chatgptChangeResposne[key] || '';


                      const value = String(original).includes('\n')
                        ? original
                        : String(original)
                      // let titleContent;


                      return (
                        <React.Fragment key={key}>
                          <div className="report-section" style={{ marginBottom: 25 }}>

                            {/* {titleContent} */}

                            <div className="titleColored" style={{
                              padding: "6px 10px", borderTop: " 2px solid #000", borderBottom: " 2px solid #000",
                              background: this.props.schoolData?.primaryColor, color: "#fff", fontWeight: "bold", fontSize: 16, marginBottom: 4
                            }}>
                              {key}:

                            </div>
                            <div style={{
                              background: "#f4f7fa",
                              borderRadius: 4,
                              padding: 12,
                              fontSize: 15,
                              color: "#222",
                              border: "1px solid #e0e0e0",
                              whiteSpace: "normal",

                            }}>
                              {/* {typeof value === 'object' && value !== null
                              ? value
                              : value} */}


                              <style>
                                {`
                                  @media print {
                                    .textarea-fontFamily {
                                      font-family: 'Open Sans', sans-serif !important;
                                    }
                                  }
                                `}
                              </style>

                              <div id={`printable-report-${report.id}`}>
                                {/* Printable content here */}

                                <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }}>

                                  <span className="textarea-fontFamily"
                                    dangerouslySetInnerHTML={{
                                      __html: value.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>").replace(/\*(.*?)\*/g, "<b>$1</b>")
                                    }}
                                  />

                                </pre>

                              </div>
                              {/*   */}
                              {/* {Array.isArray(value)
                                ? value.map((point, idx) => (
                                  <p key={idx} style={{ marginBottom: 6 }}>{point}</p>
                                ))
                                : <p>{value}</p>
                                } */}
                            </div>
                          </div>
                          {/* {(index + 1) % 4 === 0 && (
                             <div style={{ pageBreakAfter: "always" }} />
                          )} */}
                        </React.Fragment>
                      );
                    })}


                    {/* Fixed logo for print */}
                    <div
                      className="footer-logo"
                      style={{
                        position: 'fixed',
                        top: "auto",
                        bottom: '0px',
                        width: '100%',
                        textAlign: 'center',
                        zIndex: 10000
                      }}
                    >
                      <img
                        src="https://gritdev.s3.us-east-2.amazonaws.com/admin/image17380446332194438"
                        alt="School Logo"
                        style={{ height: '30px', position: "absolute", bottom: "0px" }}
                      />
                    </div>

                  </div>

                </div>

              </form>

            ))}
            {this.renderEmailModal()}


          </div>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/evaluation/reportGeneratemodal.tsx